<div
  class="status-flex"
  [ngClass]="{
    'color-error': displayType === StatusDisplayType.ERROR,
    'color-success': displayType === StatusDisplayType.SUCCESS,
    'color-info': displayType === StatusDisplayType.INFO
  }"
>
  <rad-icon
    class="rad-icon"
    [ngClass]="{
      'rad-icon-color-error': displayType === StatusDisplayType.ERROR,
      'rad-icon-color-success': displayType === StatusDisplayType.SUCCESS,
      'rad-icon-color-info': displayType === StatusDisplayType.INFO
    }"
    [attr.name]="iconName"
    size="md"
    [title]="displayValue"
  ></rad-icon>
  <span>{{ displayValue }}</span>
</div>
